const CmsFeaturedSellerBioService = {
  /**
   * Service for shrinking bio value to be 65 characters and add . . . at the end. So can be displayed neatly in the table.
   *
   * @param {bio} string - Bio Featured Seller
   */
  format: (bio) => {
    if (!bio) return bio

    return `${bio.slice(0, 64)}. . .`
  }
}

export default CmsFeaturedSellerBioService
